import { render, staticRenderFns } from "./ForumPostEdit.vue?vue&type=template&id=689bf375&"
import script from "./ForumPostEdit.vue?vue&type=script&lang=js&"
export * from "./ForumPostEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports